/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantSettings
 */
export interface TenantSettings {
    /**
     * 
     * @type {string}
     * @memberof TenantSettings
     */
    stripeId?: string | null;
}

/**
 * Check if a given object implements the TenantSettings interface.
 */
export function instanceOfTenantSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantSettingsFromJSON(json: any): TenantSettings {
    return TenantSettingsFromJSONTyped(json, false);
}

export function TenantSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stripeId': !exists(json, 'stripeId') ? undefined : json['stripeId'],
    };
}

export function TenantSettingsToJSON(value?: TenantSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stripeId': value.stripeId,
    };
}

